import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const LOANS_SIDEBAR_STORAGE_KEY = 'loans-sidebar';

type State = {
  sessionId: string | null;
  bootId: string | null;
  openItems: Record<string, boolean>;
};

type Actions = {
  toggleOpenItem: (id: string) => void;
  openAll: () => void;
  closeAll: () => void;
  resetOpenItems: (openItems: Record<string, boolean>) => void;
  setSessionId: (sessionId: string | null) => void;
  setBootId: (bootId: string | null) => void;
};

const persistMiddleware = persist<State & Actions>(
  (set, get) => ({
    sessionId: null,
    bootId: null,
    openItems: {},
    toggleOpenItem: id => {
      set({ openItems: { ...get().openItems, [id]: !get().openItems?.[id] } });
    },
    openAll: () => {
      set({
        openItems: Object.keys(get().openItems).reduce(
          (acc, curr) => ({ ...acc, [curr]: true }),
          {},
        ),
      });
    },
    closeAll: () => {
      set({
        openItems: Object.keys(get().openItems).reduce(
          (acc, curr) => ({ ...acc, [curr]: false }),
          {},
        ),
      });
    },
    resetOpenItems: openItems => {
      set({ openItems });
    },
    setSessionId: sessionId => {
      set({ sessionId });
    },
    setBootId: bootId => {
      set({ bootId });
    },
  }),
  {
    name: LOANS_SIDEBAR_STORAGE_KEY,
    storage: createJSONStorage(() => localStorage),
  },
);

export const useSidebarShowSubItems = create(persistMiddleware);
